import type { OrderSummary } from '../../../types/order-summary'
import { buildOrderSummary } from '../../../types/order-summary'
import {buildContractNumber} from '../../../types/contract-number'

const normalizeOrderSummary = function (input: Object): OrderSummary {
  return {
    ...buildOrderSummary,
    id: input.id,
    orderDate: new Date(input.orderDate),
    contractNumber: input.contractNumber ? buildContractNumber(input.contractNumber.number) : null,
    orderType: input.orderType,
    status: input.status
  }
}

export {
  normalizeOrderSummary
}



// WEBPACK FOOTER //
// ./src/services/b2b/normalizer/order-summary-normalizer.js